import { RequestService } from '~/services/RequestService'
import { API_AUTH } from '~/shared/const/api-config'

export class CollegesSortingService {
  constructor(private requestService: RequestService) {}

  readonly urls = {
    collegesSorting: '/api/v1/yavagro/colleges/sort-variables',
    collegesFilterFields: '/api/v1/yavagro/colleges/filter-fields'
  }

  readonly auth = API_AUTH

  public async getCollegesSortingList<T>(): Promise<T> {
    const res: any = await this.requestService.request<T>({
      url: `${this.urls.collegesSorting}`,
      auth: this.auth
    })

    return res.data.data
  }

  public async getCollegesFilterFields<T>(query: object): Promise<T> {
    const q = Object.keys(query)
      .map(key => `${key}=${encodeURI(query[key])}`)
      .join('&')

    const res: any = await this.requestService.request<T>({
      url: `${this.urls.collegesFilterFields}?${q}`,
      auth: this.auth
    })

    return res.data.data
  }
}
